import React from "react";

const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "Mar 2021 - May 2021",
      title: "Full-Stack Web Development Bootcamp, MERN Stack",
      place: "Ironhack | Berlin, Germany",
      desc: (
        <>
          <ul className={"mb-0"}>
            <li className="mb-2">
              Intensive 9-week, 400+ hour program focused on modern web
              development
            </li>
            <li className="mb-2">
              Built three complete full-stack applications from scratch
            </li>
            <li className="mb-2">
              Technologies: MongoDB, Express.js, React, Node.js, JavaScript, Git
            </li>
            <li>
              Agile methodology, pair programming, and collaborative development
              practices
            </li>
          </ul>
        </>
      ),
      credential: {
        id: "32768559",
        url: "https://www.credential.net/1dcc6187-bb62-42f3-9cfd-df8c0a531db5#acc.V3iCF5ln",
      },
    },
    {
      yearRange: "Sep 2016 - Jul 2017",
      title: "Software and Internet Technologies (One Year Completed)",
      place: "Technical University of Varna | Varna, Bulgaria",
      desc: (
        <>
          <ul className={"mb-0"}>
            <li className="mb-2">
              Successfully completed all first-year coursework and examinations
            </li>
            <li className="mb-2">
              Courses included: Programming Fundamentals, Data Structures,
              Algorithms, Database Design, Mathematics, and Physics
            </li>
            <li>
              Left due to family financial circumstances; gained valuable
              foundational CS knowledge
            </li>
          </ul>
        </>
      ),
    },
    {
      yearRange: "Sep 2012 - Jun 2016",
      title: "High School Diploma, IT and Informatics",
      place: "Lyuben Karavelov | Dobrich, Bulgaria",
      desc: (
        <>
          <ul className={"mb-0"}>
            <li className="mb-2">
              Specialized profile: Technological - Information Technologies
            </li>
            <li className="mb-2">
              Final Grade: 5.58/6.00 (Excellent with Honors)
            </li>
            <li className="mb-2">
              Focused on computer science foundations, programming, and
              algorithmic problem-solving
            </li>
            <li>
              Developed strong mathematical foundation and early programming
              skills
            </li>
          </ul>
        </>
      ),
    },
  ];

  const experienceDetails = [
    {
      yearRange: "Oct 2022 - Jan 2025",
      title: "Frontend Engineer",
      place: "Vehiculum new mobility GmbH",
      desc: (
        <>
          <ul className={"mb-0"}>
            <li className="mb-2">
              Key contributor in designing a BFF (Backend-for-Frontend)
              architecture with tRPC, providing a fully type-safe API
              integration layer that reduced data-fetching bugs by 50% and
              bridged frontend-backend engineering streams.
            </li>
            <li className="mb-2">
              Built a high-performance, SCSS-driven dynamic rendering system for
              consumer emission labels, removing all external image provider API
              dependencies, delivering a 30% performance improvement in page
              load times, and eliminating a €300,000 regulatory compliance risk.
            </li>
            <li className="mb-2">
              Migrated from Tailwind to Mantine UI and led the platform upgrade
              to v7; streamlined component lifecycle and styling architecture,
              reducing UI bugs by 35% and ensuring deep design system
              consistency.
            </li>
            <li className="mb-2">
              Deployed complex React components into a Webflow CMS framework
              with a custom Webpack + AWS S3 deployment pipeline, overcoming
              static CMS limitations to provide dynamic, high-fidelity marketing
              interfaces.
            </li>
            <li className="mb-2">
              Led the development of internationalization (i18n) infrastructure
              with the implementation of i18next and Locize to improve
              localization handoffs for non-technical teams and speed up market
              expansion across Europe.
            </li>
            <li className="mb-2">
              Co-led technical workshops with senior engineers and mentored
              junior developers on best practices in React, TypeScript, and
              state management, resulting in measurable improvements in team
              velocity and code maintainability.
            </li>
            <li>
              Translated complex Figma prototypes into scalable and optimized UI
              components, managing complex client-side state to ensure seamless
              interactivity, responsive design, and high visual fidelity.
            </li>
          </ul>
        </>
      ),
    },
  ];

  const skills = [
    { name: "React", icon: "fab fa-react", isCustomSvg: false },
    {
      name: "TypeScript",
      icon: "/images/typescript-icon.svg",
      isCustomSvg: true,
    },
    { name: "Next.js", icon: "/images/nextjs-icon.svg", isCustomSvg: true },
    { name: "Vue.js", icon: "fab fa-vuejs", isCustomSvg: false },
    { name: "HTML5", icon: "fab fa-html5", isCustomSvg: false },
    { name: "CSS3", icon: "fab fa-css3-alt", isCustomSvg: false },
    { name: "Tailwind", icon: "fas fa-wind", isCustomSvg: false },
    { name: "Mantine UI", icon: "fas fa-palette", isCustomSvg: false },
    { name: "Node.js", icon: "fab fa-node-js", isCustomSvg: false },
    { name: "Express", icon: "fas fa-server", isCustomSvg: false },
    { name: "MongoDB", icon: "fas fa-database", isCustomSvg: false },
    { name: "tRPC", icon: "fas fa-exchange-alt", isCustomSvg: false },
    { name: "Zustand", icon: "fas fa-cube", isCustomSvg: false },
    { name: "Git", icon: "fab fa-git-alt", isCustomSvg: false },
    { name: "GitHub", icon: "fab fa-github", isCustomSvg: false },
    { name: "Jest", icon: "fas fa-vial", isCustomSvg: false },
    { name: "Python", icon: "fab fa-python", isCustomSvg: false },
    { name: "Pygame", icon: "fas fa-gamepad", isCustomSvg: false },
  ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>

        {/* My Experience */}
        <div className="mb-5">
          <h2
            className={"text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")}
          >
            Professional Experience
          </h2>
          {experienceDetails.length > 0 &&
            experienceDetails.map((value, index) => (
              <div
                key={index}
                className={
                  "bg-white  rounded p-4 mb-4 " +
                  (darkTheme ? "bg-dark" : "bg-white border")
                }
              >
                <p className="badge bg-primary text-2 fw-400">
                  {value.yearRange}
                </p>
                <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                  {value.title}
                </h3>
                <p className={darkTheme ? "text-primary" : "text-danger"}>
                  {value.place}
                </p>
                <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                  {value.desc}
                </p>
              </div>
            ))}
        </div>

        {/* My Skills */}
        <div className="mb-5">
          <h2
            className={"text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")}
          >
            Technical Skills
          </h2>
          <div className="row g-4 justify-content-center">
            {skills.map((skill, index) => (
              <div key={index} className="col-4 col-sm-3 col-md-2 text-center">
                <div className="skill-item d-flex flex-column align-items-center">
                  <div
                    className={
                      "rounded-circle p-3 mb-2 d-flex align-items-center justify-content-center" +
                      (darkTheme
                        ? " bg-dark border border-light"
                        : " bg-light border")
                    }
                    style={{ width: "64px", height: "64px" }}
                  >
                    {skill.isCustomSvg ? (
                      <img
                        src={skill.icon}
                        alt={skill.name}
                        style={{ width: "32px", height: "32px" }}
                      />
                    ) : (
                      <i
                        className={
                          `${skill.icon} fa-2x ` +
                          (darkTheme ? "text-light" : "text-primary")
                        }
                      ></i>
                    )}
                  </div>
                  <span
                    className={
                      "text-center small " + (darkTheme ? "text-light" : "")
                    }
                  >
                    {skill.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* My Education */}
        <div className="mb-5">
          <h2
            className={"text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")}
          >
            Education
          </h2>
          {educationDetails.length > 0 &&
            educationDetails.map((value, index) => (
              <div
                key={index}
                className={
                  "bg-white  rounded p-4 mb-4 " +
                  (darkTheme ? "bg-dark" : "bg-white border")
                }
              >
                <p className="badge bg-primary text-2 fw-400">
                  {value.yearRange}
                </p>
                <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                  {value.title}
                </h3>
                <p className={darkTheme ? "text-primary" : "text-danger"}>
                  {value.place}
                </p>
                <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                  {value.desc}
                  {value.credential && (
                    <>
                      <span className="d-block mt-2">Credential ID: </span>
                      <a
                        href={value.credential.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary"
                      >
                        {value.credential.id}
                      </a>
                    </>
                  )}
                </p>
              </div>
            ))}
        </div>

        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href="alkin_maystorov_resume.pdf"
            download
          >
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
